module.exports = __webpack_public_path__ + "static/media/5.d629a2b5.jpg";